export const getInitialImageForTaskId = (taskId) => {
    // Statt useState verwenden wir einfach einen direkten Zugriff auf den Parameter
    const taskIdToUse = taskId || parseInt(new URLSearchParams(window.location.search).get("taskid"), 10);

    // Einfache Bildpfaderstellung
    const taskSpecificPath = `/initial_images/${taskIdToUse}.png`;

    // Direkt das Array mit dem Bildpfad zurückgeben
    console.log(`Initialbild für Task ${taskIdToUse}: ${taskSpecificPath}`);
    return [taskSpecificPath];
};

export const updateUrlWithTaskAndIteration = (taskId, iteration) => {
    const currentUrl = new URL(window.location.href);
    if (taskId) currentUrl.searchParams.set("taskid", taskId.toString());
    if (iteration !== undefined) currentUrl.searchParams.set("iteration", iteration.toString());
    window.history.replaceState({}, '', currentUrl.toString());
  };